import * as XLSX from "xlsx";
import {
    EvenDayParts,
    langTypes,
    multiLangType,
    OddDayParts,
    quizElement,
    UploadType,
    WritingQuizSide,
    WritingType
} from "../../enums/ExcelEnum";
import {
    columnType,
    dialogueModel,
    evenDayModel,
    oddDayModel,
    reqWriting,
    reqWritingQuizContent,
    rowType, speakingModel
} from "./model/excelModel"


class ExcelUtil {

    constructor() {
        this.sheets = [];
        this.totalSteps = [];
        this.listToCheckForDuplicacy = [];
        this.totalDays = [];
        this.header = [];
        this.oddDays = [];
        this.oddDayParts = [];
        this.oddDay = Object.assign({}, oddDayModel);
        this.evenDays = [];
        this.evenDayParts = [];
        this.currentPart = '';
        this.evenDay = Object.assign({}, evenDayModel);
        this.writingQuiz = Object.assign({}, reqWritingQuizContent)
        this.writingDescription = Object.assign({}, reqWriting)
        this.currentWritingType = WritingType.WORD;

        this.tempSequenceForDialog = 0;
        this.tempSequenceForWriting = 0;
        this.tempSequenceForSpeaking = 0;
    }

    initExcelData = () => {
        this.initSheets();
        this.initSteps();
        this.initDays();
        this.initTotalSteps();
        this.initDuplicateCheckList();
    }


    initSteps = () => {
        this.initTotalDays();
    }

    initDays = () => {
        this.initTotalDays();
        this.initOddDays();
        this.initEvenDays();
        this.initOddDayModel();
        this.initEvenDayModel();
    }

    initSheets = () => {
        this.sheets.forEach(() => this.sheets.pop());
    }
    addSheetInfo = (sheet) => {
        this.sheets.push(sheet);
    }
    getSheetInfo = () => {
        return this.sheets;
    }

    getDuplicateCheckList = () => {
        return [...this.listToCheckForDuplicacy];
    }

    getTotalDays = () => {
        return this.totalDays;
    }

    initOddDayModel = () => {
        this.oddDay = JSON.parse(JSON.stringify(oddDayModel))
        this.initOddDayParts();
    }
    initEvenDayModel = () => {
        this.evenDay = JSON.parse(JSON.stringify(evenDayModel));
        this.evenDay.reqDialogues = [];
        this.evenDay.writingQuizContent = {};
        this.evenDay.reqWritings = [];
        this.evenDay.reqSpeakings = [];
        this.initEvenDayParts();
    }


    initOddDayParts = () => {
        this.oddDayParts.forEach(() => this.oddDayParts.pop());
    }
    initOddDays = () => {
        this.oddDays.forEach(() => this.oddDays.pop());
    }

    initEvenDayParts = () => {
        this.evenDayParts = [];
    }
    initEvenDays = () => {
        this.evenDays.forEach(() => this.evenDays.pop());
    }

    initTotalDays = () => {
        this.totalDays.forEach(() => this.totalDays.pop());
    }
    initWritingQuiz = () => {
        this.writingQuiz = JSON.parse(JSON.stringify(reqWritingQuizContent));
    }
    initWritingDescription = () => {
        this.writingDescription = JSON.parse(JSON.stringify(reqWriting));
    }

    initTotalSteps = () => {
        this.totalSteps.forEach(() => this.totalSteps.pop());
    }

    initDuplicateCheckList = () => {
        this.listToCheckForDuplicacy.forEach(() => this.listToCheckForDuplicacy.pop());
        console.log("this.listToCheckForDuplicacy :", this.listToCheckForDuplicacy);
    }
    addTotalSteps = (steps) => {
        this.totalSteps.push(steps);
    }

    addTotalDays = (step, day) => {
        if (!this.totalDays.includes(day)) {
            this.totalDays.push(day);
            this.setDuplicateCheckList(step, day);
        }
    }

    addOddDayParts = (part) => {
        if (!this.oddDayParts.includes(part)) {
            this.oddDayParts.push(part);
        }
    }
    addEvenDayParts = (part) => {
        if (!this.evenDayParts.includes(part)) {
            this.evenDayParts.push(part);
        }
    }

    addOddDays = (oddDay) => {
        this.oddDays.push(oddDay);
        this.oddDays.sort((oddDay1, oddDay2) => oddDay1.day - oddDay2.day);
    }
    addEvenDays = (evenDay) => {
        this.evenDays.push(evenDay);
        this.evenDays.sort((evenDay1, evenDay2) => evenDay1.day - evenDay2.day);
    }

    addDialogues = (dialogue) => {
        this.evenDay.reqDialogues.push(dialogue);
    }
    addWritingQuiz = (quiz) => {
        this.evenDay.writingQuizContent = quiz;
    }
    addWritingDescription = (writing) => {
        this.evenDay.reqWritings.push(writing);
    }
    addSpeakingPart = (speaking) => {
        this.evenDay.reqSpeakings.push(speaking);
    }

    setHeader = (header) => {
        this.header = header;
    }
    setCurrentPart = (part) => {
        this.currentPart = part;
    }
    setWritingQuizInfo = (type, wq) => {
        this.writingQuiz[type] = wq;
    }
    setWritingDescriptionInfo = (type, wq) => {
        this.writingDescription[type] = wq;
    }
    setWritingDescriptionDetailInfo = (type, el, wq) => {
        this.writingDescription[type][el] = wq;
    }

    setDuplicateCheckList = (step, day) => {
        const obj = {step: step, day: day};
        this.listToCheckForDuplicacy = [...this.listToCheckForDuplicacy, obj];
    }


    setData = async (step, data, uploadType = UploadType.ALL, day = 0) => {

        let currentDay = 0;
        let nextRow = 0;
        const languageList = langTypes.concat(multiLangType);
        console.log(languageList);
        await languageList.forEach(lang => {
            this.initEvenDayModel();
            this.initOddDayModel();

            data.forEach(async (row, rindex) => {
                if (rindex === 0) {
                    return
                }
                if (row[0]) {
                    if (!isNaN(Number(row[0]))) {
                        // console.log("current Day ",row[0])
                        currentDay = row[0]
                        if (uploadType === UploadType.PART && !isNaN(day) && day !== 0 && currentDay !== day) {

                        } else {
                            this.addTotalDays(step, currentDay);
                        }
                    } else {
                        this.initEvenDayModel();
                        this.initOddDayModel();
                        return;
                    }
                }

                if (uploadType === UploadType.PART && !isNaN(day) && day !== 0 && currentDay !== day) {
                    // console.log("📕 step :",step," currentDay : ",currentDay, "  will not load");

                } else {
                    // console.log("📗 step :",step," currentDay : ",currentDay, " lang : ", lang, "  will load");
                    if (data[rindex + 1]) {
                        nextRow = data[rindex + 1];
                    }

                    let isLastContentOfTheDay = this.isLastContentOfTheDay(currentDay, nextRow);

                    if (currentDay % 2 === 0) {
                        await this.setEvenDay(step, currentDay, row, lang, isLastContentOfTheDay, nextRow);
                    } else {
                        // console.log("Last ? ",isLastContentOfTheDay)
                        await this.setOddDay(step, currentDay, row, lang,isLastContentOfTheDay);
                    }
                }

            })
        });
        // console.log("Set Days DONE!")
    }

    isLastContentOfTheDay = (currentDay, nextRow) => {
        if (nextRow) {
            const nextDay = nextRow[0];
            return !!nextDay && nextDay !== currentDay;
        } else {
            return true;
        }
    }

    uploadExcelFileByStepAndDay = async (file, uploadType, stepValue = 0, dayValue = 0, callback) => {
        this.initExcelData();
        console.log("📘 uploading excel file");
        const reader = new FileReader();
        const rABS = !!reader.readAsBinaryString;
        this.loadExcelFileByStepAndDay(reader, rABS, uploadType, stepValue, dayValue);
        if (rABS) {
            await reader.readAsBinaryString(file);
        } else {
            await reader.readAsArrayBuffer(file);
        }
        console.log(this.sheets)


        reader.onloadend = () => {
            console.log("📗 loaded ");
            callback(this.getDuplicateCheckList());
        }
    }


    uploadExcelFile = async (file, uploadType, callback) => {
        this.initExcelData();
        // console.log(📙📗📕📘);
        console.log("📘 uploading excel file");
        const reader = new FileReader();
        const rABS = !!reader.readAsBinaryString;
        await this.readExcelFile(reader, rABS, callback);
        if (rABS) {
            reader.readAsBinaryString(file);
        } else {
            reader.readAsArrayBuffer(file);
        }

        reader.onloadend = () => {
            console.log("📗 loaded ");
            callback(this.getDuplicateCheckList());
        }
    }

    readExcelFile = (reader, rABS) => {
        console.log("📘 reading excel file");
        let days = [];
        reader.onload = async e => {

            const bstr = e.target.result;
            const wb = XLSX.read(bstr, {type: rABS ? "binary" : "array"});

            const steps = this.getStepFromExcel(wb.SheetNames);

            for (const step of steps) {

                this.initDays();
                const sheetNumber = Number(step.split("Step-")[1]);
                const ws = wb.Sheets[step];
                let data = XLSX.utils.sheet_to_json(ws, {header: 1});
                this.setHeader(data[rowType.Header]);
                await this.setData(sheetNumber, data);
                days = await this.combineAndSortDays(this.totalDays, this.evenDays, this.oddDays);
                this.addSheetInfo({
                    step: sheetNumber,
                    days: days,
                });
            }
        };

    }

    loadExcelFileByStepAndDay = (reader, rABS, uploadType, stepValue, stepDay) => {
        console.log("📘 reading excel file");
        let days = [];
        reader.onload = async e => {

            const bstr = e.target.result;
            const wb = XLSX.read(bstr, {type: rABS ? "binary" : "array"});

            if (!isNaN(stepDay) && stepDay !== 0) {
                this.addTotalSteps(stepValue);
            }

            this.initDays();

            const sheetNumber = stepValue;
            const sheetName = "Step-" + stepValue;
            const ws = wb.Sheets[sheetName];
            let data = XLSX.utils.sheet_to_json(ws, {header: 1});

            this.setHeader(data[rowType.Header]);
            await this.setData(sheetNumber, data, uploadType, stepDay);

            days = await this.combineAndSortDays(this.totalDays, this.evenDays, this.oddDays);
            this.addSheetInfo({
                step: sheetNumber,
                days: days,
            });
        };
    }


    combineAndSortDays = (totalDays, evenDays, oddDays) => {
        let listToSend = [];
        totalDays.forEach((day) => {
            let list = [];
            if (day % 2 === 0) {
                list = evenDays.filter(oddDay => oddDay.day === day);
            } else {
                list = oddDays.filter(oddDay => oddDay.day === day);
            }
            listToSend.push({day: day, list: list});
            list = [];
        });
        return listToSend;
    }

    getStepFromExcel = (sheetNames) => {


        return sheetNames.filter(sheetName => {
            if (sheetName.includes("Step-")) {
                const sheetNumber = sheetName.split("Step-")[1];
                this.addTotalSteps(sheetNumber);
                return sheetName;
            }
            return null;
        }).filter((sheetName) => sheetName !== null);


    }

    setOddDay = (step, currentDay, row, lang,isLastContentOfTheDay) => {

        const contentRow = columnType[lang];
        const currentPart = row[columnType.PART];
        const content = row[contentRow] || "";
        const voice = row[columnType.AdditionalInfo] || 'Man';

        // console.log("@@@@@@@")
        // console.log(`STEP :${step}, DAY : ${currentDay}, Language: ${lang}, PART: ${currentPart}`)
        if (currentPart) {

            this.setCurrentPart(currentPart);
            this.addOddDayParts(currentPart);

        }
        // console.log("[]->",this.oddDayParts);
        // console.log("@@@@@@@")

        if (multiLangType.includes(lang)) {
            if (this.currentPart === OddDayParts.Listening) {
                const koreanLangIndex = this.oddDays.findIndex(oddDay => ((oddDay.languageCode === langTypes[0]) && (oddDay.step === step) && (oddDay.day === currentDay)))
                // console.log("korean Language Index : ",koreanLangIndex)
                this.oddDays[koreanLangIndex].listening.multiTranslates.push({languageCode: lang, text: content});
            }
        } else {
            if (this.currentPart === OddDayParts.Listening) {

                this.oddDay.listening.voiceType = voice;
                this.oddDay.listening.listeningContent.step = step;
                this.oddDay.listening.listeningContent.day = currentDay;
                this.oddDay.listening.listeningContent.text = content;
                this.oddDay.listening.listeningContent.languageCode = lang;

            } else if (this.currentPart === OddDayParts.Listening1) {

                this.oddDay.listening1 = content;

            } else if (this.currentPart === OddDayParts.Listening2) {

                this.oddDay.listening2 = content;

            } else if (this.currentPart === OddDayParts.Listening3) {

                this.oddDay.listening3.content = content;
                this.oddDay.listening3.voiceType = voice;

            } else if (this.currentPart === OddDayParts.Sentence) {

                this.oddDay.sentence = content;

            } else if (this.currentPart === OddDayParts.Hearing) {


                this.oddDay.hearing = content;
                this.oddDay.step = step;
                this.oddDay.day = currentDay;
                this.oddDay.languageCode = lang;

                if (lang === langTypes[0]) {
                    // console.log("content for Hearing \n ",content)
                    // console.log("this.oddDayParts : ",this.oddDayParts)
                    this.checkOddDayPartsAllWritten(currentDay);

                }

                this.addOddDays(this.oddDay);

            }
        }
        if (isLastContentOfTheDay)  {
            this.initOddDayModel();
        }
    }

    setEvenDay = (step, currentDay, row, lang, isLastContentOfTheDay, nextContent) => {

        const currentPart = row[columnType.PART];

        if (currentPart) {

            this.setCurrentPart(currentPart);
            if (lang === langTypes[0]) {
                this.addEvenDayParts(this.currentPart);
            }
        }
        if (multiLangType.includes(lang)) {
            this.setMultiLanguageEvenContents(step, currentDay, row, lang, isLastContentOfTheDay);
        } else {

            if (this.currentPart === EvenDayParts.Dialogue) {

                this.setDialoguePart(step, currentDay, row, lang);

            } else if (this.currentPart === EvenDayParts.Writing1) {

                this.setWritingQuiz(step, currentDay, row, lang);

            } else if (this.currentPart === EvenDayParts.Writing2) {

                this.setWritingList(step, currentDay, row, lang);

            } else if (this.currentPart === EvenDayParts.Speaking) {

                this.setSpeakingList(step, currentDay, row, lang);

                if (lang === langTypes[0]) {
                    //TODO 최초에 파트 검사하는 로직 적용
                    this.checkEvenDayPartsAllWritten(currentDay);
                }

                if (isLastContentOfTheDay) {

                    this.evenDay.step = step;
                    this.evenDay.day = currentDay;
                    this.evenDay.languageCode = lang;
                    this.addEvenDays(this.evenDay);
                    this.initEvenDayModel();
                    return;

                }

            } else {

                if (lang === langTypes[0]) {
                    //TODO 최초에 파트 검사하는 로직 (테스트용)
                    // console.warn(`${currentDay} day 파트 언어 :${lang} 입력에서 오류 : `, this.currentPart);
                    // console.warn("📙 : ", row);

                }
            }
        }
    }

    setDialoguePart = (step, currentDay, row, lang) => {

        let dialogue = JSON.parse(JSON.stringify(dialogueModel));

        const text = row[columnType[lang]];
        const additionalInfo = row[columnType.AdditionalInfo];
        const splitList = additionalInfo.split("/")
        const speakerName = splitList[0];
        const voice = splitList[1] || "Man";

        if (lang === langTypes[0]) {
            if (!text) {
                console.warn("dialogue is missing content");
            }
        }

        dialogue.dialogue = {
            step: step,
            day: currentDay,
            languageCode: lang,
            text: text,
            sequence: this.evenDay.reqDialogues.length,
            speakerName: speakerName,
        };
        dialogue.voiceType = voice;

        this.addDialogues(dialogue);
    }

    setWritingQuiz = (step, currentDay, row, lang) => {

        const additionalInfo = row[columnType.AdditionalInfo];
        const content = row[columnType[lang]];

        this.setWritingQuizInfo(quizElement.STEP, step);
        this.setWritingQuizInfo(quizElement.DAY, currentDay);
        this.setWritingQuizInfo(quizElement.LANGUAGE_CODE, lang);

        if (additionalInfo === WritingQuizSide.LEFT) {

            this.setWritingQuizInfo(quizElement.LEFT_WORD, content);

        } else if (additionalInfo === WritingQuizSide.RIGHT) {

            this.setWritingQuizInfo(quizElement.RIGHT_WORD, content);
            this.addWritingQuiz(this.writingQuiz);
            this.initWritingQuiz();

            //TODO 왼쪽엔 있는데 오른쪽에 없으면 에러처리 필요
        }
    }

    setWritingList = (step, currentDay, row, lang) => {

        const voice = row[columnType.AdditionalInfo] || "Man";
        const content = row[columnType[lang]];

        this.setWritingDescriptionDetailInfo(quizElement.WRITING_CONTENT, quizElement.STEP, step);
        this.setWritingDescriptionDetailInfo(quizElement.WRITING_CONTENT, quizElement.DAY, currentDay);
        this.setWritingDescriptionDetailInfo(quizElement.WRITING_CONTENT, quizElement.LANGUAGE_CODE, lang);
        this.setWritingDescriptionDetailInfo(quizElement.WRITING_CONTENT, quizElement.SEQUENCE, this.evenDay.reqWritings.length);

        if (this.currentWritingType === WritingType.WORD) {

            this.setWritingDescriptionDetailInfo(quizElement.WRITING_CONTENT, quizElement.WORD, content);
            this.currentWritingType = WritingType.DESCRIPTION;

        } else if (this.currentWritingType === WritingType.DESCRIPTION) {

            this.setWritingDescriptionInfo(quizElement.DESCRIPTION, content);
            this.currentWritingType = WritingType.WORD;
            this.setWritingDescriptionInfo(quizElement.VOICE_TYPE, voice);
            this.setWritingDescriptionInfo(quizElement.MULTI_TRANSLATES, []);
            this.addWritingDescription(this.writingDescription);
            this.initWritingDescription();

        }
    }

    setSpeakingList = (step, currentDay, row, lang) => {
        const voice = row[columnType.AdditionalInfo] || "Man";
        const content = row[columnType[lang]];

        let speaking = JSON.parse(JSON.stringify(speakingModel));

        speaking.speakingContent.step = step;
        speaking.speakingContent.day = currentDay
        speaking.speakingContent.languageCode = lang
        speaking.speakingContent.text = content
        speaking.speakingContent.sequence = this.evenDay.reqSpeakings.length
        speaking.voiceType = voice;
        speaking.multiTranslates = [];

        this.addSpeakingPart(speaking);
    }


    setMultiLanguageEvenContents = (step, currentDay, row, lang, isLastContentOfTheDay) => {
        const text = row[columnType[lang]];
        const koreanLangIndex = this.evenDays.findIndex(evenDay => ((evenDay.languageCode === langTypes[0]) && (evenDay.step === step) && (evenDay.day === currentDay)));

        if (this.evenDays[koreanLangIndex] && text) {

            if (this.currentPart === EvenDayParts.Dialogue) {
                if (this.evenDays[koreanLangIndex]?.reqDialogues && this.evenDays[koreanLangIndex]?.reqDialogues.length > 0) {
                    this.evenDays[koreanLangIndex].reqDialogues[this.tempSequenceForDialog].multiTranslates.push({
                        languageCode: lang,
                        text: text
                    });
                    this.tempSequenceForDialog++;
                }
            } else if (this.currentPart === EvenDayParts.Writing2) {
                if (this.evenDays[koreanLangIndex]?.reqWritings && this.evenDays[koreanLangIndex].reqWritings.length > 0 && this.evenDays[koreanLangIndex].reqWritings[this.tempSequenceForWriting]?.description) {
                    this.evenDays[koreanLangIndex].reqWritings[this.tempSequenceForWriting].multiTranslates.push({
                        languageCode: lang,
                        text: text
                    });
                    this.tempSequenceForWriting++;
                }
            } else if (this.currentPart === EvenDayParts.Speaking) {
                if (this.evenDays[koreanLangIndex]?.reqSpeakings && this.evenDays[koreanLangIndex].reqSpeakings.length > 0 && this.evenDays[koreanLangIndex]?.reqSpeakings[this.tempSequenceForWriting]?.speakingContent?.text) {
                    this.evenDays[koreanLangIndex].reqSpeakings[this.tempSequenceForSpeaking].multiTranslates.push({
                        languageCode: lang,
                        text: text
                    });
                    this.tempSequenceForSpeaking++;
                }
            }
        }

        if (isLastContentOfTheDay) {

            this.tempSequenceForDialog = 0;
            this.tempSequenceForWriting = 0;
            this.tempSequenceForSpeaking = 0;

        }
    }


    checkOddDayPartsAllWritten = () => {

        this.oddDay.allPartsWritten = Object.values(OddDayParts)
            .every(oddPart => {
                return this.oddDayParts.includes(oddPart);
            });
    }

    checkEvenDayPartsAllWritten = () => {

        this.evenDay.allPartsWritten = Object.values(EvenDayParts)
            .every(evenPart => {
                return this.evenDayParts.includes(evenPart);
            });
    }


}

export const EXCEL_UTIL = new ExcelUtil();

